<!--
  PC 双侧固定侧栏：左侧为装饰；右侧「回顶」滚动由 Layout 统一处理 window
  显隐由路由 meta.showPcSidebar 控制（在 Layout 中 v-if）
-->
<template>
  <aside class="pc-sidebar" :aria-label="pcSidebarCopy.asideAriaLabel">
    <div class="pc-sidebar__left">
      <div class="pc-sidebar__left-inner">
        <div class="pc-sidebar__left-arrows" aria-hidden="true">
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--l1">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_one.webp"
              :alt="sidebarArrowDownAlt(1, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_two.webp"
              :alt="sidebarArrowDownAlt(1, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_three.webp"
              :alt="sidebarArrowDownAlt(1, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--l2">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_one.webp"
              :alt="sidebarArrowDownAlt(2, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_two.webp"
              :alt="sidebarArrowDownAlt(2, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_three.webp"
              :alt="sidebarArrowDownAlt(2, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--l3">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_one.webp"
              :alt="sidebarArrowDownAlt(3, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_two.webp"
              :alt="sidebarArrowDownAlt(3, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_bottom_three.webp"
              :alt="sidebarArrowDownAlt(3, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
        </div>

        <div class="pc-sidebar__left-inner-stat" aria-hidden="true">
          <img
            src="@/assets/image/index/to_bottom.webp"
            alt=""
            width="52"
            height="70"
            decoding="async"
          />
        </div>
      </div>
    </div>
    <div class="pc-sidebar__right">
      <div class="pc-sidebar__right-inner">
        <div
          class="pc-sidebar__right-arrows"
          role="button"
          tabindex="0"
          :aria-label="pcSidebarCopy.toTopImgAlt"
          @click="onToTop"
          @keydown.enter.prevent="onToTop"
          @keydown.space.prevent="onToTop"
        >
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--r1">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_one.webp"
              :alt="sidebarArrowUpAlt(1, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_two.webp"
              :alt="sidebarArrowUpAlt(1, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_three.webp"
              :alt="sidebarArrowUpAlt(1, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--r2">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_one.webp"
              :alt="sidebarArrowUpAlt(2, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_two.webp"
              :alt="sidebarArrowUpAlt(2, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_three.webp"
              :alt="sidebarArrowUpAlt(2, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
          <div class="pc-sidebar__arrow-slot pc-sidebar__arrow-slot--r3">
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_one.webp"
              :alt="sidebarArrowUpAlt(3, 1)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_two.webp"
              :alt="sidebarArrowUpAlt(3, 2)"
              width="16"
              height="58"
              decoding="async"
            />
            <img
              class="pc-sidebar__arrow-state"
              src="@/assets/image/index/triangle_top_three.webp"
              :alt="sidebarArrowUpAlt(3, 3)"
              width="16"
              height="58"
              decoding="async"
            />
          </div>
        </div>

        <button
          type="button"
          class="pc-sidebar__right-inner-btn"
          @click="onToTop"
        >
          <span class="pc-sidebar__to-top-wrap">
            <img
              class="pc-sidebar__to-top-img"
              src="@/assets/image/index/to_top.webp"
              :alt="pcSidebarCopy.toTopImgAlt"
              width="52"
              height="70"
              decoding="async"
            />
            <img
              class="pc-sidebar__to-top-img pc-sidebar__to-top-img--hover"
              src="@/assets/image/index/to_top_hover.webp"
              alt=""
              width="52"
              height="70"
              decoding="async"
              aria-hidden="true"
            />
          </span>
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import indexContent from '@/views/data/index-content.json'

export default {
  name: 'PcSidebar',
  data() {
    return {
      pcSidebarCopy: indexContent.pcSidebar,
    }
  },
  methods: {
    onToTop() {
      this.$emit('to-top')
    },
    sidebarArrowDownAlt(col, frame) {
      const p = this.pcSidebarCopy.arrowDownAltPattern
      return p.replace('{col}', String(col)).replace('{frame}', String(frame))
    },
    sidebarArrowUpAlt(col, frame) {
      const p = this.pcSidebarCopy.arrowUpAltPattern
      return p.replace('{col}', String(col)).replace('{frame}', String(frame))
    },
  },
}
</script>

<style lang="scss" scoped>
.pc-sidebar {
  img {
    box-sizing: border-box;
    vertical-align: middle;
  }

  &__left {
    position: fixed;
    left: 0;
    top: 0;
    width: 80px;
    height: 100vh;
    background-color: #f8a5fd;
    /* 高于全屏弹层（约 200–250） */
    z-index: 300;

    &-inner {
      position: relative;
      width: 78px;
      height: 100%;
      background-color: #1f1f1f;
      border-radius: 40px 0px 0px 0;

      &-btn,
      &-stat {
        position: absolute;
        /* 矮屏/窄屏：vh 过小时用 vh+vmin 保底留白（避免仅用 px 被 pxtorem 随宽度压得过小） */
        top: max(37.778vh, 5vh, 2.5vmin);
        left: 50%;
        transform: translate(-50%, 0);
        transform-origin: center center;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        font: inherit;
        line-height: 0;
        /* 略小于栏宽，高度与 vh 箭头区同量级，避免按钮过大 */
        max-width: 68%;
        max-height: 6.5vh; /* ≈70/1080 */

        img {
          display: block;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 6.5vh;
          object-fit: contain;
          pointer-events: none;
        }
      }

      &-stat {
        cursor: default;
        pointer-events: none;
        user-select: none;
      }

      &-btn {
        cursor: pointer;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        transition:
          transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1),
          filter 0.2s ease;

        &:hover {
          transform: translate(-50%, 0) scale(1.06);
          filter: brightness(1.12) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.35));
        }

        &:active {
          transform: translate(-50%, 0) scale(0.92);
          filter: brightness(0.92);
          transition-duration: 0.08s;
        }

        &:focus-visible {
          outline: 2px solid #37fff1;
          outline-offset: 3px;
          border-radius: 4px;
        }
      }
    }
  }

  &__right {
    position: fixed;
    right: 0;
    top: 0;
    width: 78px;
    padding-left: 2px;
    height: 100vh;
    background-color: #f8a5fd;
    z-index: 300;

    &-inner {
      position: relative;
      width: 78px;
      height: 100%;
      background-color: #1f1f1f;
      border-radius: 0px 0px 40px 0;

      &-btn {
        position: absolute;
        bottom: max(7.731vh, 5vh, 2.5vmin);
        left: 50%;
        transform: translate(-50%, 0);
        transform-origin: center center;
        cursor: pointer;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        font: inherit;
        line-height: 0;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        /* 略小于栏宽，高度与 vh 箭头区同量级，避免按钮过大 */
        max-width: 68%;
        max-height: 6.5vh; /* ≈70/1080 */
        transition:
          transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1),
          filter 0.2s ease;

        img {
          display: block;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 6.5vh;
          object-fit: contain;
          pointer-events: none;
        }

        &:hover {
          transform: translate(-50%, 0) scale(1.06);
          filter: brightness(1.12) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.35));

          .pc-sidebar__to-top-img:not(.pc-sidebar__to-top-img--hover) {
            opacity: 0;
          }

          .pc-sidebar__to-top-img--hover {
            opacity: 1;
          }
        }

        &:active {
          transform: translate(-50%, 0) scale(0.92);
          filter: brightness(0.92);
          transition-duration: 0.08s;
        }

        &:focus-visible {
          outline: 2px solid #37fff1;
          outline-offset: 3px;
          border-radius: 4px;
        }
      }
    }
  }

  &__to-top-wrap {
    position: relative;
    display: inline-block;
    line-height: 0;
  }

  &__to-top-img {
    transition: opacity 0.2s ease;

    &--hover {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }

  /* 按 1080p 设计稿换算 vh，与 rem（随宽度变化）解耦，窄屏下间距与箭头同步缩放 */
  /*
   * 箭头区须可接收 hover：若父级为 pointer-events:none，flex 的 gap 会穿透事件，
   * 窄箭槽又极难对准；整块 arrows 设为 auto，仅占用侧栏箭头带宽度，不挡主内容区。
   */
  &__left-arrows {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 8.981481vh; /* 97/1080 */
    gap: 4.444444vh; /* (203-97-58)/1080，相邻箭头净间距 */
    box-sizing: border-box;
    pointer-events: auto;
  }

  &__right-arrows {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    /* 设计 176/1080 + 额外留白：滚顶按钮距底约 83.5/1080，按钮有固有高度，小屏下易与最下箭头叠在一起 */
    padding-bottom: calc(16.296296vh + 5.555556vh); /* +60/1080，整体上移 */
    gap: 4.444444vh;
    box-sizing: border-box;
    pointer-events: auto;
    cursor: pointer;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
    border: none;
    background: transparent;
    font: inherit;
    color: inherit;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    text-align: inherit;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid #37fff1;
      outline-offset: 3px;
      border-radius: 4px;
    }
  }

  &__arrow-slot {
    position: relative;
    flex-shrink: 0;
    width: 1.481481vh; /* 16/1080 */
    height: 5.37037vh; /* 58/1080 */
    line-height: 0;
    overflow: visible;
  }

  &__arrow-state {
    display: block;
    position: absolute;
    left: 50%;
    top: 0;
    width: 1.481481vh;
    height: 5.37037vh;
    transform: translateX(-50%);
    z-index: 1;
    box-sizing: border-box;
    object-fit: contain;
    opacity: 0;
    pointer-events: none;
    animation: none;
  }

  /*
   * 默认：三列各亮一帧（左侧由下方无限 animation 覆盖；右侧未悬停时保持静态）。
   * 右侧 __right-arrows 为 column-reverse，视觉上从上到下为 r3→r2→r1，
   * 与左侧对齐须 r3→第1张、r2→第2张、r1→第3张。
   */
  &__arrow-slot--l1 &__arrow-state:nth-child(1),
  &__arrow-slot--l2 &__arrow-state:nth-child(2),
  &__arrow-slot--l3 &__arrow-state:nth-child(3),
  &__arrow-slot--r1 &__arrow-state:nth-child(3),
  &__arrow-slot--r2 &__arrow-state:nth-child(2),
  &__arrow-slot--r3 &__arrow-state:nth-child(1) {
    opacity: 1;
  }

  /* 左侧：自动无限循环。右侧：悬停时同套 animation（须完整简写以覆盖 animation: none） */
  &__left-arrows &__arrow-slot--l1 &__arrow-state:nth-child(1),
  &__right-inner:hover &__arrow-slot--r1 &__arrow-state:nth-child(1) {
    animation: pc-sidebar-arrow-blink-1 1.2s linear 0s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l1 &__arrow-state:nth-child(2),
  &__right-inner:hover &__arrow-slot--r1 &__arrow-state:nth-child(2) {
    animation: pc-sidebar-arrow-blink-2 1.2s linear 0s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l1 &__arrow-state:nth-child(3),
  &__right-inner:hover &__arrow-slot--r1 &__arrow-state:nth-child(3) {
    animation: pc-sidebar-arrow-blink-3 1.2s linear 0s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l2 &__arrow-state:nth-child(1),
  &__right-inner:hover &__arrow-slot--r2 &__arrow-state:nth-child(1) {
    animation: pc-sidebar-arrow-blink-1 1.2s linear 0.15s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l2 &__arrow-state:nth-child(2),
  &__right-inner:hover &__arrow-slot--r2 &__arrow-state:nth-child(2) {
    animation: pc-sidebar-arrow-blink-2 1.2s linear 0.15s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l2 &__arrow-state:nth-child(3),
  &__right-inner:hover &__arrow-slot--r2 &__arrow-state:nth-child(3) {
    animation: pc-sidebar-arrow-blink-3 1.2s linear 0.15s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l3 &__arrow-state:nth-child(1),
  &__right-inner:hover &__arrow-slot--r3 &__arrow-state:nth-child(1) {
    animation: pc-sidebar-arrow-blink-1 1.2s linear 0.3s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l3 &__arrow-state:nth-child(2),
  &__right-inner:hover &__arrow-slot--r3 &__arrow-state:nth-child(2) {
    animation: pc-sidebar-arrow-blink-2 1.2s linear 0.3s infinite backwards;
  }

  &__left-arrows &__arrow-slot--l3 &__arrow-state:nth-child(3),
  &__right-inner:hover &__arrow-slot--r3 &__arrow-state:nth-child(3) {
    animation: pc-sidebar-arrow-blink-3 1.2s linear 0.3s infinite backwards;
  }

  @media (prefers-reduced-motion: reduce) {
    &__right-inner-btn:hover,
    &__right-inner-btn:active {
      transform: translate(-50%, 0) !important;
      filter: none !important;
      transition: none !important;
    }

    &__arrow-state {
      animation: none !important;
      opacity: 0;
    }

    &__arrow-slot--l1 &__arrow-state:nth-child(1),
    &__arrow-slot--l2 &__arrow-state:nth-child(2),
    &__arrow-slot--l3 &__arrow-state:nth-child(3),
    &__arrow-slot--r1 &__arrow-state:nth-child(3),
    &__arrow-slot--r2 &__arrow-state:nth-child(2),
    &__arrow-slot--r3 &__arrow-state:nth-child(1) {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
@keyframes pc-sidebar-arrow-blink-1 {
  0%,
  33.32% {
    opacity: 1;
  }
  33.33%,
  100% {
    opacity: 0;
  }
}

@keyframes pc-sidebar-arrow-blink-2 {
  0%,
  33.32% {
    opacity: 0;
  }
  33.33%,
  66.65% {
    opacity: 1;
  }
  66.66%,
  100% {
    opacity: 0;
  }
}

@keyframes pc-sidebar-arrow-blink-3 {
  0%,
  66.65% {
    opacity: 0;
  }
  66.66%,
  99.99% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
